export const SESSION_MODEL_THINKING_OFF_VARIANT = "off";

export function normalizeSessionModelThinkingVariant(
  value: string | null | undefined,
): string | null {
  if (!value) return null;

  const normalized = value.trim().toLowerCase();
  if (!normalized) return null;
  if (normalized === "off" || normalized === "none") {
    return SESSION_MODEL_THINKING_OFF_VARIANT;
  }
  if (/^x[\s_-]*high$/.test(normalized)) {
    return "xhigh";
  }

  return normalized;
}
